import { Injectable } from '@angular/core';
import { ExternalAction, ExternalActionData } from './external.action.interface';
import { DeletePlantActions } from './external-actions/delete.plant.action';
import { DeleteUserActions } from './external-actions/delete.user.action';

@Injectable()
export class ExternalActionsService {
    constructor(private deletePlantAction: DeletePlantActions, private deleteUserAction: DeleteUserActions) {
        window.addEventListener('angular-action', (e: any) => this.handleAction(e.detail), false);
        this.registerAction(deletePlantAction);
        this.registerAction(deleteUserAction);
    }

    private actions: Array<ExternalAction> = [];

    public registerAction(action: ExternalAction) {
        this.actions.push(action);
    }

    private handleAction(data: ExternalActionData) {
        const action = this.actions.find((current) => current.name === data.name);
        if (action) {
            action.execute(data);
        } else {
            console.info('ExternalAction Error, cannot find action!', data.name);
        }
    }
}
